/**
 * @file Defines the {@link UI_SIDES} constant
 * @author Joe Thompson <joe.thompson@1x2gaming.com>
 */

/**
 * Sides the UI consists of.
 * @type {string[]}
 * @constant
 * @default
 */
const UI_SIDES = [

    'leftWrapper',
    'rightWrapper'

]

export { UI_SIDES }
